import script from "./InspectorMaterial.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectorMaterial.vue?vue&type=script&setup=true&lang=js"

import "./InspectorMaterial.vue?vue&type=style&index=0&id=34153271&lang=scss&scoped=true"
import "./InspectorMaterial.vue?vue&type=style&index=1&id=34153271&lang=scss"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34153271"]])

export default __exports__